import React, { useState } from "react";
import { connect } from "react-redux";
import { Button } from "antd";
import SummaryHeader from "components/header/SummaryHeader";
import SummaryItem from "components/header/SummaryItem";
import PerformanceReviewTab from "./components/PerformanceReviewTab";
import HeaderModal from "components/modal/HeaderModal";
import PerformanceFramework from "./components/PerformanceFramework";
import { Award, LucideCalendar, LucideClock, LucideSparkles } from "lucide-react";

const PerformanceReviews = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <div>
      <div className="mt-5">
        <SummaryHeader
          title={"Performance Reviews"}
          icon={Award}
          color="purple"
          description={"Conduct and manage employee performance evaluations"}
          rightNav={
            <Button
              onClick={openModal}
              className="flex items-center justify-center gap-2 rounded-lg text-sm font-medium h-9 px-4 py-2 bg-white/20 border border-white/30 text-white"
            >
              <LucideSparkles className="h-4 w-4" />
              <span className="hidden sm:inline">
                View Framework
              </span>
            </Button>
          }
        >
          
          <div className="summary-item-container">
            <SummaryItem
            title="Total Employees"
            icon={<LucideCalendar className="w-4 h-4" />}
            display="9"
            />
            <SummaryItem
              title="Reviews Due"
              icon={<Award className="w-4 h-4" />}
              display="9"
            />
            <SummaryItem
              title="Overdue"
              icon={<LucideClock className="w-4 h-4" />}
              display="9"
            />
          </div>
        </SummaryHeader>
      </div>
      <div className="w-full mt-6">
          <PerformanceReviewTab />
      </div>

      <HeaderModal
        open={isModalOpen}
        onClose={closeModal}
        title="Hyvid Performance Framework"
        description="At Hyvid, performance is about more than outcomes — it's about how we work, collaborate, and grow together."
        bgcolor="white"
        width={500}
        footer={
          <div className="p-4 flex justify-end">
            <Button
              className="inline-flex items-center justify-center gap-2 rounded-xl text-sm bg-green-500 text-white font-medium h-9 px-4"
              onClick={closeModal}
            >
              Close
            </Button>
          </div>
        }
      >
        <div className="max-h-[60vh] overflow-y-auto">
          <PerformanceFramework />
        </div>
      </HeaderModal>
    </div>
  );
};

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PerformanceReviews);
